module.exports = function() {
  return new Worker(__webpack_public_path__ + "901c4bdc19ea12a7296b.worker.js");
};